import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const tileVariants = cva(
  "rounded-2xl overflow-hidden relative transition-all duration-200",
  {
    variants: {
      variant: {
        white: "bg-white dark:bg-zinc-900",
        cream: "bg-[#faf8f5] dark:bg-zinc-800/80",
        dark: "bg-zinc-900 dark:bg-zinc-950 text-white",
        accent: "bg-primary-600 text-white",
      },
      interactive: {
        true: "hover:-translate-y-px hover:shadow-elevated-hover cursor-pointer",
        false: "",
      },
    },
    defaultVariants: {
      variant: "white",
      interactive: false,
    },
  }
);

export interface TileProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tileVariants> {}

function Tile({ className, variant, interactive, ref, ...props }: TileProps & { ref?: React.Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      className={cn(tileVariants({ variant, interactive }), className)}
      {...props}
    />
  );
}

export { Tile, tileVariants };
